/* eslint import/prefer-default-export: "off" */
export const GRIDICS_SITE_LINKS = {
  REPORTS_LINK:
    'https://gridics.com/property-zoning-reports/?utm_source=PropZone%20Property%20Report%20Inquiry&utm_medium=PZ%20detail%20page%20banner&utm_campaign=pz_report_sales#explore',
  SAMPLE_FEASIBILITY_REPORT_LINK:
    'https://gridics.com/wp-content/themes/gridics2020/dist/files/sample-development-feasibility-report.pdf',
  SAMPLE_PDF_REPORT_LINK: '/samples/Zoning Report 169 E FLAGLER ST Miami FL 33131.pdf',
  SAMPLE_CSV_REPORT_LINK: '/samples/Property Data Report 169 E FLAGLER ST Miami FL 33131.csv',
};

export const GTM_CTA_CONTENT = {
  DOWNLOAD_REPORTS: 'Generate zoning feasibility report for this property.',
  DOWNLOAD_PDF_REPORT: 'Purchase a zoning report for this property.',
  PURCHASE_PDF_REPORT: 'Purchase Single Property Report',
  FEASIBILITY_REPORTS: {
    EVENT: 'ctaClick',
    BANNER_GTM_DATA: {
      category: 'Button Click',
      action: 'Property Detail Feasibility Report',
    },
    VIEW_SAMPLE_GTM_DATA: {
      category: 'Link Click',
      action: 'Property Detail Feasibility Report',
    },
    SECTIONS: {
      'property-details': {
        LEARN_MORE: 'Property Detail - Learn More',
        VIEW_SAMPLE: 'Property Detail Tab - View Sample Link',
      },
      zoning: {
        LEARN_MORE: 'Zoning - Learn More',
        VIEW_SAMPLE: 'Zoning Tab - View Sample Link',
      },
      'development-potential': {
        LEARN_MORE: 'Dev Potential - Learn More',
        VIEW_SAMPLE: 'Dev Potential Tab - View Sample Link',
      },
      'my-properties': {
        ACTION: 'My Properties Feasibility Report',
        LEARN_MORE: 'My Properties - Learn More',
        VIEW_SAMPLE: 'My Properties - View Sample Link',
      },
      'user-menu': {
        ACTION: 'User Menu Feasibility Report',
        LEARN_MORE: 'User Menu - Learn More',
      },
    },
  },
  PDF_REPORTS: {
    EVENT: 'ctaClick',
    BANNER_GTM_DATA: {
      category: 'Button Click',
      action: 'Property Detail PDF Report',
    },
    VIEW_SAMPLE_GTM_DATA: {
      category: 'Link Click',
      action: 'Property Detail PDF Report',
    },
    SECTIONS: {
      'results-card': {
        ACTION: 'Results Card - Purchase PDF Report',
      },
      'property-details': {
        VIEW_SAMPLE: 'Property Detail Tab - View Sample Link',
      },
      zoning: {
        VIEW_SAMPLE: 'Zoning Tab - View Sample Link',
      },
      'development-potential': {
        VIEW_SAMPLE: 'Dev Potential Tab - View Sample Link',
      },
    },
  },
  CSV_REPORTS: {
    EVENT: 'ctaClick',
    BANNER_GTM_DATA: {
      category: 'Button Click',
      action: 'Property Detail CSV Report',
    },
    VIEW_SAMPLE_GTM_DATA: {
      category: 'Link Click',
      action: 'Property Detail CSV Report',
    },
    SECTIONS: {
      'property-details': {
        VIEW_SAMPLE: 'Property Detail Tab - View CSV Sample Link',
      },
    },
  },
};
